/**
 * @class ResponseMessageConstants
 * @classdesc A class that contains static properties for error and welcome messages.
 */
export class ResponseMessageConstants {

  /**
   * An error message that displays when an error occurs.
   * @property
   * @type {Object}
   * @property {string} title - Title of the error message.
   * @property {string} message - Description of the error message
   */
  static readonly DEFAULT_ERROR = {
    title: 'une erreur est survenue',
    message: 'veuillez réessayer ultérieurement'
  };
  /**
   * A welcome message that displays after a new account is created.
   * @property
   * @type {Object}
   * @property {string} title - Title of the welcome message.
   * @property {string} message - Description of the welcome messag
   */
  static readonly WELCOME = {
    title: '🎉Félicitations🎉',
    message: 'Un nouveau compte a été créé. Veuillez vérifier votre e-mail pour obtenir le mot de passe pour vous connecter.'
  };

  /**
   * A message that displays after a user go to the login page while he was logged in.
   * @property
   * @type {Object}
   * @property {string} title - Title of the Information message.
   * @property {string} message - Description of the message
   */
  static readonly ALREADY_LOGIN = {
    title: '😊Information😊',
    message: 'Il semble que vous vous soyez déjà connecté.'
  };

  static readonly UPLOAD_SUCCESS = {
    title: '😊Information😊',
    message: 'Les données ont été transférées, l\'image est enfin prête à être visualisée !'
  };
  static readonly SUCCESS = {
    title: '🎉Félicitations🎉',
    message: 'Un nouveau besoin a été ajouté avec succès.'
  };
  static readonly UPDATE_SUCCESS = {
    title: '🎉Félicitations🎉',
    message: 'Les informations ont été modifiées'
  };
}
